import { cn } from "@/lib/utils/helpers";
import type { EntityEditHeaderCardProps } from "./EntityEditHeaderCard.types";

export type { EntityEditHeaderCardProps } from "./EntityEditHeaderCard.types";

/**
 * Top header card for entity edit pages: primary label + optional right column toolbar (same layout as Company edit).
 */
export function EntityEditHeaderCard({ lead, toolbar, className, innerClassName }: EntityEditHeaderCardProps) {
    return (
        <div className={cn("mx-4 mt-4 sm:mx-6", className)}>
            <div
                className={cn(
                    "rounded-xl border border-slate-200/90 bg-white px-4 py-5 shadow-sm sm:px-6",
                    innerClassName,
                )}
            >
                <div
                    className={cn(
                        "flex flex-col gap-5",
                        toolbar && "lg:flex-row lg:items-start lg:justify-between lg:gap-8",
                    )}
                >
                    <div className="min-w-0 flex-1">{lead}</div>
                    {toolbar ? (
                        <div className="flex w-full min-w-0 max-w-full flex-col gap-3 self-stretch lg:w-auto lg:shrink-0 lg:items-end">
                            {toolbar}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
